import gql from 'graphql-tag'

export const CREATE_PLAYLIST = gql`
  mutation academyCreatePlaylist($playlist: CreatePlaylistInput!) {
    academyCreatePlaylist(playlist: $playlist) {
      id
      slug
    }
  }
`

export const UPDATE_PLAYLIST = gql`
  mutation academyUpdatePlaylist($playlistId: Int!, $playlist: UpdatePlaylistInput!) {
    academyUpdatePlaylist(playlistId: $playlistId, playlist: $playlist) {
      coursePlaylists {
        course {
          id
          duration
          name
          type
          status
          topics {
            id
            mediaFromTime
            mediaToTime
          }
        }
      }
      cover
      desc
      id
      name
      schoolId
      status
      slug
      totalTime
      playlistAssign {
        id
        assignTo
        type
      }
    }
  }
`

export const DUPLICATE_PLAYLIST = gql`
  mutation academyDuplicatePlaylist($playlistId: Int!) {
    academyDuplicatePlaylist(playlistId: $playlistId) {
      name
      id
      desc
      slug
      status
      insertedAt
      updatedAt
      userId
      school {
        id
        name
      }
      playlistAssign {
        courseEnrolls {
          userId
        }
        id
        type
        assignTo
      }
      coursePlaylists {
        course {
          id
        }
      }
    }
  }
`

export const REMOVE_PLAYLIST = gql`
  mutation academyRemovePlaylist($playlistId: Int!) {
    academyRemovePlaylist(playlistId: $playlistId)
  }
`

export const ACTIVATE_PLAYLIST = gql`
  mutation academyActivatePlaylist($playlistId: Int!) {
    academyActivatePlaylist(playlistId: $playlistId) {
      id
      slug
    }
  }
`

export const DEACTIVATE_PLAYLIST = gql`
  mutation academyDeactivatePlaylist($playlistId: Int!) {
    academyDeactivatePlaylist(playlistId: $playlistId) {
      id
      slug
    }
  }
`
